<template>
  <v-container fluid class="tour-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Tour</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                      <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">New Tour</p>
                        <v-select
                          class="mb-4"
                          :items="tourtypes"
                          v-model="new_tour.tourtype"
                          v-bind:error="error == 'tourtype'"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the tour type">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="new_tour.tourcode"
                          v-bind:error="error == 'tourcode'"
                          outlined
                          dense
                          placeholder="Tour Code"
                          persistent-hint
                          single-line hint="Enter the tour code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_tour.tourname"
                          v-bind:error="error == 'tourname'"
                          outlined
                          dense
                          placeholder="Tour Name"
                          persistent-hint
                          single-line hint="Enter the tour name">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="vendors.filter(x=>x.vendortype=='Supplier').map(x => { return {text: x.vendorname, value: x._id}})"
                          v-model="new_tour.vendorid"
                          v-bind:error="error == 'vendorid'"
                          outlined
                          dense
                          placeholder="Vendor"
                          persistent-hint
                          single-line hint="Please choose vendor">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="countries.map(x => {
                            return {text: x.countryname, value: x._id};
                          })"
                          v-model="new_tour.countryid"
                          v-bind:error="error == 'countryid'"
                          outlined
                          dense
                          placeholder="Country"
                          persistent-hint
                          single-line hint="Please choose country">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="cities.map(x => {
                            return {text: x.cityname, value: x._id};
                          })"
                          v-model="new_tour.cityid"
                          v-bind:error="error == 'cityid'"
                          outlined
                          dense
                          placeholder="City"
                          persistent-hint
                          single-line hint="Please choose city">
                        </v-select>
                        <v-row no-gutters>
                        <v-col cols="12" md="5">
                          <v-text-field
                            type="number"
                            class="mb-4"
                            outlined
                            dense
                            v-model="new_tour.tourdays"
                            v-bind:error="error == 'tourdays'"
                            placeholder="Tour Days"
                            persistent-hint
                            single-line hint="Num of days">
                          </v-text-field>
                        </v-col>
                        <div style="width: 15px;"></div>
                        <v-col cols="12" md="5">
                          <v-text-field
                            type="number"
                            class="mb-4"
                            outlined
                            dense
                            v-model="new_tour.tournights"
                            v-bind:error="error == 'tournights'"
                            placeholder="Tour Nights"
                            persistent-hint
                            single-line hint="Num of nights">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="new_tour.tourtitle"
                          outlined
                          dense
                          placeholder="Tour Title"
                          v-bind:error="error == 'tourtitle'"
                          persistent-hint
                          single-line hint="Please enter tour title">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_tour.toursubtitle"
                          outlined
                          dense
                          placeholder="Tour Subtitle"
                          v-bind:error="error == 'toursubtitle'"
                          persistent-hint
                          single-line hint="Please enter tour subtitle">
                        </v-text-field>
                        <v-textarea
                            v-model="new_tour.tourdesc"
                            outlined
                            rows=3
                            label="Description"
                            hint="please enter the tour description"
                        ></v-textarea>
                        <v-text-field
                          class="mb-4"
                          v-model="new_tour.tourkeyword"
                          outlined
                          dense
                          placeholder="Keywords"
                          persistent-hint
                          single-line hint="Enter keywords">
                        </v-text-field>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12" sm="12">
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/tour/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertTour()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      new_tour: {},
      tourtypes: ["Group Tour" , "Private Tour", "Free & Easy"],
      numofvariations: [1,2,3,4],
      variationtypes: ["HotelRating", "HotelType", "HotelName", "RoomType", "BedType", "DayType", "TourType", "TransferType", "MealType"],
      error: undefined,
      errorindex: undefined,
      haserror: false,
    }
  },

  methods: {
    ...mapActions('', ['getVendorsRequest']),
    ...mapActions('City', ['getCitiesRequest']),
    ...mapActions('Country', ['getCountriesRequest']),
    ...mapActions('Tour', ['insertTourRequest','insertTourWithImageRequest','getToursRequest']),
    ...mapActions('Vendor', ['getVendorsRequest']),
    checkError(){
      if(!this.new_tour.tourtype){
        this.error = 'tourtype';
        return false;
      }
      if(!this.new_tour.tourcode){
        this.error = 'tourcode';
        return false;
      }
      if(!this.new_tour.tourname){
        this.error = 'tourname';
        return false;
      }
      if(!this.new_tour.vendorid){
        this.error = 'vendorid';
        return false;
      }
      if(!this.new_tour.countryid){
        this.error = 'countryid';
        return false;
      }
      if(!this.new_tour.tourdays){
        this.error = 'tourdays';
        return false;
      }
      if(!this.new_tour.tournights){
        this.error = 'tournights';
        return false;
      }
      if(!this.new_tour.tourtitle){
        this.error = 'tourtitle';
        return false;
      }
      if(!this.new_tour.toursubtitle){
        this.error = 'toursubtitle';
        return false;
      }
      this.error = null;
      this.step = 2;
      return true;
    },
    async insertTour() {
      console.log(this.new_tour)
      if(this.new_tour.tourimage!=null) await this.insertTourWithImageRequest(this.new_tour);
      else await this.insertTourRequest(this.new_tour);
      router.push('/tour/list')
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => { this.imageurl = e.target.result };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.new_tour.tourimage = file;
      this.new_tour.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('City', ['cities']),
    ...mapState('Country', ['countries']),
    ...mapState('Tour', ['isReceiving']),
    ...mapState('Vendor', ['vendors']),
  },
  async created(){
    if(this.cities.length==0) await this.getCitiesRequest();
    if(this.countries.length==0) await this.getCountriesRequest();
    if(this.vendors.length==0) await this.getVendorsRequest();
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
